//For password encryption in API it is accepting only 16 bytes
//The Key should be 16 bytes only
export const PASSWORD_ENCRYPT_KEY = '9kkj-dkj18c-e96f';
export const ENCRYPT_KEY = '9kkj-dkj18c-e96f5a9ac85a';
export const APPCODE = 'Web'; //Used in login
export const INACTIVE_USER_TIME_THRESHOLD = 2220000; //Threshold for session timeout 37 mins
export const USER_ACTIVITY_THROTTLER_TIME = 1000; //To reset check for inactivity 1 sec
export const SYSTEM_ERROR =
  'Unable to perform this transaction, please try later.'; //Api error static message
